export default __webpack_public_path__ + "static/media/Minicard_Jc.47521427.svg";